import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import TransferenciaEstadoService from '../../../../../services/transferenciasEstado-auth';
import { Link, useParams, Navigate } from 'react-router-dom';


const Transferencia = () => {
    let { id } = useParams()

    const [origem, setOrigem] = useState("");
    const [competencia, setCompetencia] = useState("");
    const [valor, setValor] = useState("");
    const [tipo, setTipo] = useState("");
    const [destinatario, setDestinatario] = useState("");
    const [programa, setPrograma] = useState("");
    const [ano, setAno] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchTransferencia(id) {
        const response = await TransferenciaEstadoService.transEdit(id);
        setOrigem(response.data["origem"]);
        setCompetencia(response.data["competencia"]);
        setValor(response.data["valor"]);
        setTipo(response.data["tipo"]);
        setDestinatario(response.data["destinatario"]);
        setPrograma(response.data["programa"]);
        setAno(response.data["ano"]);
    }

    useEffect(() => {
        fetchTransferencia(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const transferencia = await TransferenciaEstadoService.editar({
                origem: origem,
                competencia: competencia,
                valor: valor,
                tipo: tipo,
                destinatario: destinatario,
                programa: programa,
                ano: ano
            })
            if (transferencia.data["_id"]) {
                alert("Transferência editada com sucesso!")
                setSucesso(true);
            }
            else {
                alert(transferencia.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="origem">
                                <FloatingLabel
                                    label="Origem"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="origem"
                                        name="origem"
                                        onChange={e => setOrigem(e.target.value)}
                                    >
                                        <option value={origem}>{origem}</option>
                                        <option value="FUNDEB - ICMS">FUNDEB - ICMS</option>
                                        <option value="ICMS">ICMS</option>
                                        <option value="FUNDEB - IPI">FUNDEB - IPI</option>
                                        <option value="FUNDEB - IPVA">FUNDEB - IPVA</option>
                                        <option value="IPI">IPI</option>
                                        <option value="IPVA">IPVA</option>
                                        <option value="PASEP - IPI">PASEP - IPI</option>
                                        <option value="ROYALTIES">ROYALTIES</option>
                                        <option value="PASEP - ROYALTIES">PASEP - ROYALTIES</option>
                                        <option value="FUNDEB - ICMS - LEI EST. 5.647/10">FUNDEB - ICMS - LEI EST. 5.647/10</option>
                                        <option value="ICMS - LEI EST. 5.647/10">ICMS - LEI EST. 5.647/10</option>
                                        <option value="FUNDEB - IPVA - LEI EST. 5.647/10">FUNDEB - IPVA - LEI EST. 5.647/10</option>
                                        <option value="ICM - LEI EST. 5.647/10">ICM - LEI EST. 5.647/10</option>
                                        <option value="IPVA - LEI EST. 5.647/10">IPVA - LEI EST. 5.647/10</option>
                                        <option value="FUNDEB - ICMS - DECRETO 44.814/2014">FUNDEB - ICMS - DECRETO 44.814/2014</option>
                                        <option value="ICMS - DECRETO 44.814/2014">ICMS - DECRETO 44.814/2014</option>
                                        <option value="COMP. LC 194/2022">COMP. LC 194/2022</option>
                                        <option value="FUNDEB - ICMS - LC 194/2022">FUNDEB - ICMS - LC 194/2022</option>
                                        <option value="ICMS - LC 194/2022">ICMS - LC 194/2022</option>
                                        <option value="FUNDEB - ICMS - LEI EST. 6.136/11">FUNDEB - ICMS - LEI EST. 6.136/11</option>
                                        <option value="ICMS - LEI EST. 6.136/11">ICMS - LEI EST. 6.136/11</option>
                                        <option value="FUNDEB - IPVA - LEI EST. 6.136/11">FUNDEB - IPVA - LEI EST. 6.136/11</option>
                                        <option value="ICM - LEI EST. 6.136/11">ICM - LEI EST. 6.136/11</option>
                                        <option value="ICMS - JUROS E MORA">ICMS - JUROS E MORA</option>
                                        <option value="FUNDEB - ICMS - JUROS E MORA">FUNDEB - ICMS - JUROS E MORA</option>
                                        <option value="IPVA - JUROS E MORA">IPVA - JUROS E MORA</option>
                                        <option value="FUNDEB - IPVA - JUROS E MORA">FUNDEB - IPVA - JUROS E MORA</option>
                                        <option value="Governo do Estado do Rio de Janeiro">Governo do Estado do Rio de Janeiro</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={12}>
                            <Form.Group className="mb-3" controlId="Plataforma">
                                <FloatingLabel
                                    label="Competência"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="competencia"
                                        name="competencia"
                                        onChange={e => setCompetencia(e.target.value)}
                                    >
                                        <option value={competencia}>{competencia}</option>
                                        <option value="Janeiro">Janeiro</option>
                                        <option value="Fevereiro">Fevereiro</option>
                                        <option value="Março">Março</option>
                                        <option value="Abril">Abril</option>
                                        <option value="Maio">Maio</option>
                                        <option value="Junho">Junho</option>
                                        <option value="Julho">Julho</option>
                                        <option value="Agosto">Agosto</option>
                                        <option value="Setembro">Setembro</option>
                                        <option value="Outubro">Outubro</option>
                                        <option value="Novembro">Novembro</option>
                                        <option value="Dezembro">Dezembro</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="valor">
                                <FloatingLabel
                                    label="Valor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="programa">
                                <FloatingLabel
                                    label="Programa"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="programa"
                                        name="programa"
                                        onChange={e => setPrograma(e.target.value)}
                                    >
                                        <option value={programa}>{programa}</option>
                                        <option value="Somando Forças">Somando Forças</option>
                                        <option value="Assistência Farmacêutica">Assistência Farmacêutica</option>
                                        <option value="Gestão e Fortalecimento da Atenção à Saúde">Gestão e Fortalecimento da Atenção à Saúde</option>
                                        <option value="Fortalecimento da Gestão do SUS e da Participação Social">Fortalecimento da Gestão do SUS e da Participação Social</option>
                                        <option value="Proteção Social Básica de Assistência Social">Proteção Social Básica de Assistência Social</option>
                                        <option value="Gestão Operacional da Polícia">Gestão Operacional da Polícia</option>
                                        <option value="Promoção da Saúde e Vigilância Epidemiológica">Promoção da Saúde e Vigilância Epidemiológica</option>
                                        <option value="Vigilância Ambiental e Vigilância Sanitária">Vigilância Ambiental e Vigilância Sanitária</option>
                                        <option value="Ampliação e Qualificação da Atenção Básica">Ampliação e Qualificação da Atenção Básica</option>
                                        <option value="Promoção da Assistência Ambulatorial e Hospitalar">Promoção da Assistência Ambulatorial e Hospitalar</option>
                                        <option value="Organização da Oferta de Assistência nas Linhas de Cuidado Prioritárias">Organização da Oferta de Assistência nas Linhas de Cuidado Prioritárias</option>
                                        <option value="Coordenação Federativa e Desenvolvimento Territorial">Coordenação Federativa e Desenvolvimento Territorial</option>
                                        <option value="Vigilância em Saúde">Vigilância em Saúde</option>
                                        <option value="Atenção à Saúde">Atenção à Saúde</option>
                                        <option value="Gestão do SUAS, Proteção Social e Redução da Pobreza">Gestão do SUAS, Proteção Social e Redução da Pobreza</option>
                                        <option value=" Estratégia e Gestão da Saúde"> Estratégia e Gestão da Saúde</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="tipo">
                                <FloatingLabel
                                    label="Tipo"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="tipo"
                                        name="tipo"
                                        onChange={e => setTipo(e.target.value)}
                                    >
                                        <option value={tipo}>{tipo}</option>
                                        <option value="Obrigatória">Obrigatória</option>
                                        <option value="Voluntária">Voluntária</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="destinatario">
                                <FloatingLabel
                                    label="Destinatário"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="destinatario"
                                        name="destinatario"
                                        onChange={e => setDestinatario(e.target.value)}
                                    >
                                        <option value={destinatario}>{destinatario}</option>
                                        <option value="Prefeitura Municipal de Macuco">Prefeitura Municipal de Macuco</option>
                                        <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                        <option value="Fundo Municipal de Educação">Fundo Municipal de Educação</option>
                                        <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/transferenciasestado/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Transferência editada com sucesso!</Alert>
                <Navigate to={'/restrito/transferenciasestado/listar'} />
            </Fragment>
        )
    }
}

export default Transferencia;